/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Col_WeightInputs */

const tr_katalog_desi_page_col_weight = /** @type {(inputs: Katalog_Desi_Page_Col_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Ağırlık`)
};

const en_katalog_desi_page_col_weight = /** @type {(inputs: Katalog_Desi_Page_Col_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Weight`)
};

const de_katalog_desi_page_col_weight = /** @type {(inputs: Katalog_Desi_Page_Col_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Gewicht`)
};

const ru_katalog_desi_page_col_weight = /** @type {(inputs: Katalog_Desi_Page_Col_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Вес`)
};

/**
* | output |
* | --- |
* | "≈ Weight" |
*
* @param {Katalog_Desi_Page_Col_WeightInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_col_weight = /** @type {((inputs?: Katalog_Desi_Page_Col_WeightInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Col_WeightInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_col_weight(inputs)
	if (locale === "de") return de_katalog_desi_page_col_weight(inputs)
	if (locale === "ru") return ru_katalog_desi_page_col_weight(inputs)
	return tr_katalog_desi_page_col_weight(inputs)
});